<div hidden (click)="selectFile()">
  <input
    type="file"
    (change)="onChange($event.target.files)"
    [attr.multiple]="selectMultiple ? 'multiple':null"
    (click)="$event.target.value = null"
    #fileInputControl
  />
</div>
